import React from 'react';
import Moment from 'react-moment';
import { withRouter } from 'react-router';
import { Button } from 'components/ui/form';
import styles from '../../order.module.scss';

const Success = ({ order, onClose }) => (
  <>
    <div>
      <h2 className={styles.successTitle}>Благодарим вас за заказ!</h2>
      <p className={styles.successText}>
        Ваш заказ на вагон №
        {`${order.id} `}
        от
        {' '}
        <Moment>{order.createdAt}</Moment>
        {' '}
        создан.
      </p>
    </div>
    <div className={styles.successLinks}>
      <div>
        <Button onClick={onClose}>Мои заказы</Button>
      </div>
    </div>
  </>
);

export default withRouter(Success);
